import { createFileRoute } from '@tanstack/react-router';
import { AskSocialDataPage } from '../../../pages/tools/research-tools/AskSocialDataPage';
import { toolHead } from '../../../lib/toolHead';

export const Route = createFileRoute('/_site/tools/ask-social-data')({
  head: () => toolHead('ask-social-data'),
  component: AskSocialDataPage,
});
